<div class="home">
    <h1>
        ¿Qué quieres hacer hoy?
    </h1>
    <!--ACCESOS DIRECTOS DESKTOP-->
    <ul class="accesos">
        <li *ngFor="let acceso of filtroEstadoAcceso()">
            <div *ngIf="acceso.estado" class="button-acc azul {{acceso.class}}" (click)="handleRedirect(acceso.url)">
                <div class="icono-acc">
                    <img src="{{acceso.img}}">
                </div>
                <div class="body-acc">
                    <h3>{{acceso.alt}}</h3>
                </div>
            </div>
        </li>
    </ul>

    <!--ACCESOS DIRECTOS MOBILE-->
    <div class="carrusel-accesos-mobile">
        <div>
            <ul class="accesos-mobile">
                <li *ngFor="let acceso of filtroEstadoAcceso()">
                    <div *ngIf="acceso.estado" class="button-acc-mobile {{acceso.class}}" (click)="handleRedirect(acceso.url)">
                        <div class="icono-acc">
                            <img src="{{acceso.img}}" alt="{{acceso.alt}}">
                        </div>
                        <div class="body-acc">
                            <h3>{{acceso.alt}}</h3>
                        </div>
                    </div>
                </li>
            </ul>
        </div>
    </div>
    <p class="descripcion-scroll">Desliza hacia los lados para ver los demás accesos</p>

    <h2 class="titulo-otros-tramites">
        También puedes realizar estas solicitudes
    </h2>

    <!--WIDGETS-->
    <ul class="thumbs">
        <li class="linea-1" *ngFor="let f of filtroEstadoFormulario(); let i = index;">
            <div class="card">
                <div class="head">
                    <div class="icono">
                        <img src="{{f.img}}" alt="{{f.nombre}}" />
                    </div>
                </div>
                <div class="body">
                    <h2>
                        {{f.nombre}}
                    </h2>
                    <p>
                        {{f.descripcion}}
                    </p>
                </div>
                <div class="footer">
                    <div class="btn" (click)="handleRedirect(f.url)">
                        <p>VER MÁS</p>
                    </div>
                </div>
            </div>
        </li>
    </ul>
</div>
<ngx-spinner></ngx-spinner>
